export const SPLIT_TEST: Record<string, string | undefined> = {
  quickMessage: import.meta.env.VITE_APP_SPLIT_TEST_ZERO_FREE_MSG,
  showOverlayInNotifications: import.meta.env
    .VITE_APP_SPLIT_TEST_NOTIFICATION_OVERLAY,
  paidVideoMails: import.meta.env.VITE_APP_SPLIT_TEST_PAID_VIDEO_MAILS,
  chatStub: import.meta.env.VITE_APP_SPLIT_TEST_CHAT_STUB,
  sparkSwipeProfile: import.meta.env.VITE_APP_SPLIT_TEST_SPARK_SWIPE_PROFILE,
  reducedWizard: import.meta.env.VITE_APP_SPLIT_TEST_REDUCED_WIZARD,
  profilePreview: import.meta.env.VITE_APP_SPLIT_TEST_PROFILE_PREVIEW,
  disappearingMessage: import.meta.env.VITE_APP_SPLIT_TEST_DISAPPEARING_MESSAGE,
  getCreditsButtonSilver: import.meta.env
    .VITE_APP_SPLIT_TEST_GET_CREDITS_BUTTON_SILVER,
  getCreditsButtonGolden: import.meta.env
    .VITE_APP_SPLIT_TEST_GET_CREDITS_BUTTON_GOLDEN,
  getCreditsButtonIcon: import.meta.env
    .VITE_APP_SPLIT_TEST_GET_CREDITS_BUTTON_ICON,
  starterScreenFreeStickers: import.meta.env
    .VITE_APP_SPLIT_TEST_STARTER_SCREEN_FREE,
  starterScreenPaidStickers: import.meta.env
    .VITE_APP_SPLIT_TEST_STARTER_SCREEN_PAID,
};

export const SPLIT_TEST_STATUS_ACTIVE = 1;

export const brandsWithProfilePreview = [
  "amourlee",
  "latinmelodies",
  "cupidticket",
];
